// Components
// Types
import { Button, type TEIOption, TEInput, Tag } from '@timeedit/ui-components';
import { Space } from '@timeedit/ui-components/antd';
import CheckableTag from '@timeedit/ui-components/antd/tag/CheckableTag';
// Style
import './CheckableSelect.scss';

interface ICheckableSelectProps {
  options: TEIOption[];
  value: string[];
  onChange: (value: string[]) => void;
  highlightValue?: string[];
  label: string;
  tooltip: string;
  flow?: 'row' | 'column';
}

const CheckableSelect = ({
  options,
  value,
  onChange,
  highlightValue,
  label,
  tooltip,
  flow = 'column',
}: ICheckableSelectProps) => {
  const handleChange = (checked: boolean, key: string) => {
    if (checked) {
      onChange([...value, key]);
    } else {
      onChange(value.filter((v) => v !== key));
    }
  };
  return (
    <TEInput.LabelWrapper label={label} tooltip={tooltip} flow={flow}>
      <Space size={[8, 8]} wrap>
        {options.map((option) => {
          if (option.disabled)
            return (
              <Tag className="checkable-select-disabled" key={option.value}>
                {option.label}
              </Tag>
            );

          const isChecked = value.includes(option.value);
          const isHighlighted = highlightValue?.includes(option.value);
          return (
            <CheckableTag
              className={`checkable-select ${
                isHighlighted ? 'checkable-select--highlighted' : ''
              }`}
              key={option.value}
              checked={isChecked}
              onChange={(checked) => {
                handleChange(checked, option.value);
              }}
              data-testid="weekdays"
            >
              {option.label}
            </CheckableTag>
          );
        })}
        <Button
          size="small"
          type="text"
          style={{ fontSize: 12 }}
          onClick={() =>
            onChange(
              options
                .filter((option) => !option.disabled)
                .map((option) => option.value)
            )
          }
        >
          Select all
        </Button>
      </Space>
    </TEInput.LabelWrapper>
  );
};

export default CheckableSelect;
